import { createContext } from 'react';

// Контекст для баланса кристаллов
export const BalanceContext = createContext();

// Контекст для коллекции оружия
export const CollectionContext = createContext();

// Контекст для темы оформления
export const ThemeContext = createContext(); 